export default "__VITE_PUBLIC_ASSET__8717b5be__"